<div [class]="accent" class="m-1">
  <mat-icon [class]="accent" *ngIf="icon" class="mr-2">{{ icon }}</mat-icon>
  <ng-content></ng-content>
</div>
